import axios from 'axios'
import { demoAdapter } from '@/demo/data.cjs'
// 데모는 모든 요청을 메모리에서 처리하며 운영 주소로 전달하지 않는다.
const client = axios.create({ adapter: demoAdapter })
client.interceptors.response.use(response => {
  if (response.data.resultCode === 'DEMO_DISABLED') window.dispatchEvent(new CustomEvent('partner-demo-disabled', { detail: response.data.resultMessage }))
  return response
})
export default client
